import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../components/Buttons";
import EpisodeCard from "../components/EpisodeCard";
import { episodeData } from "../components/episodeData";

const FirstFourEpisodes = () => {
  const [firstFourEpisodes, setFirstFourEpisodes] = useState([]);

  useEffect(() => {
    setFirstFourEpisodes(episodeData.slice(0, 4));
  }, []);

  return (
    <div className="mt-10">
      <div className="flex justify-between">
        <h1 className="text-2xl text-dark-blue font-bold self-center">
          🟠 Latest Episodes
        </h1>
        <PrimaryButton btnText={"View More"} url={"/podcasts"} />
      </div>
      <div className="flex justify-between gap-5 flex-col md:flex-row md:flex-wrap">
        {firstFourEpisodes.map((episode) => {
          const {
            serialNo,
            imageUrl,
            title,
            applePodcastUrl,
            googlePodcastUrl,
            spotifyPodcastUrl,
            anchorPodcastUrl,
          } = episode;
          return (
            <EpisodeCard
              serialNo={serialNo}
              imageUrl={imageUrl}
              title={title}
              applePodcastUrl={applePodcastUrl}
              googlePodcastUrl={googlePodcastUrl}
              spotifyPodcastUrl={spotifyPodcastUrl}
              anchorPodcastUrl={anchorPodcastUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FirstFourEpisodes;
